import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const ProjectRegistration = lazy(() => import('../../container/borrower/admin-project/ProjectRegistration'));
const ProjectList = lazy(() => import('../../container/borrower/admin-project/projectList'));
const ProjectUpdate = lazy(() => import('../../container/borrower/admin-project/projectUpdate'));
const ProjectDetails = lazy(() => import('../../container/borrower/admin-project/projectDetail/projectDetails'));

export default function ProjectRoute() {
  return (
    <Routes>
      <Route path="registration" element={<ProjectRegistration />} />
      <Route path="update/:id" element={<ProjectUpdate />} />
      <Route path="detail/:id" element={<ProjectDetails />} />
      <Route path="list" element={<ProjectList />} />
    </Routes>
  );
}
